<template>
	<div class="add-sous-op-component">
		<div v-if="!isFloat && operands.every(el => el < 10)" class="one-digit-reduce">
			{{operands.join(' '+ withUnits(operator) + ' ') }} = <span class="result">{{ withUnits(result)}}</span>
		</div>
		<template v-else>
			<div class="add-subtract">
				<template v-if="estimated">
					<div class="estimation-demo">
						<div class="many-digits-operation">
							<div class="bloc-operation">
								<div class="operator">
									{{operator}}
								</div>
								<div class="operands">
									<div v-for="operand in terms" class="operand">
										{{ withUnits(read_notation(operand)) }}
									</div>
								</div>
							</div>
							<hr class="line">
							<div class="result">{{ result.toString().replace(/./gi, '?') }}</div>
						</div>
					</div>
					<div class="around-sign"> ≈ </div>
				</template>
				<div class="many-digits-operation">
					<div class="bloc-operation">
						<div class="operator">
							{{operator}}
						</div>
						<div class="operands">
							<div v-for="operand in operands" class="operand">
								{{ withUnits(read_notation(operand)) }}
							</div>
						</div>
					</div>
					<hr class="line">
					<div class="result">{{ withUnits(read_notation(result)) }}</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script type="text/javascript">
	const $operations = require("../scripts/variables").operations;
	import BaseExerciseMixin from '../../js/BaseExerciseMixin';
	export default {
		mixins: [BaseExerciseMixin],
		name: 'addition-integers',
		props: {
			terms: {type: Array, required: true},
			operator: {type: String, required: false, default: '+'},
			estimated: {type: [Boolean], required: false, default: false},
			units: { type: String, default: '' },
			demo: {type: Boolean, default: false}
		},
		data(){
			let terms = this.terms;
			if(Number(this.estimated) !== 0){
				terms = terms.estimated();
			}
			return {
				result: '',
				operands: terms,
				isFloat: this.terms.map(el => parseInt(el) != Number(el)).reduce((a, b) => a || b),
				termsOp: terms
			}
		},
		created(){
			if(this.operator == '+'){
				this.operands.sort_gt();
			}
			let res = $operations.unknow(this.operator, this.termsOp);

			if(this.operands.map(el => parseFloat(el) != parseInt(el)).reduce((a, b) => a || b, false)){
				let ld = this.operands.map(el => parseFloat(el).D_P().length).max();
				this.operands = this.operands.map(el => parseFloat(el).toFixed(ld));
			}else{
				res = parseInt(res);
			}
			this.result = res;
		},
		methods: {
			withUnits(str) {
				if (this.units.trim == '')
					return str;
				if (this.units == '$') {
					return `$${str}`;
				} else {
					return `${str} ${this.units}`;
				}
			}

		}
	};
</script>

<style lang="scss" scoped>
@import '../../styles/component-style';
	.add-sous-op-component{
		display: inline-block;
		.one-digit-reduce {}
		.add-subtract {
			display: flex;
			align-items: center;
			column-gap: 0.5rem;
			.estimation-demo {
				.result {
					color: inherit !important;
					font-weight: normal;
				}
			}
		}
		.many-digits-operation {
			.bloc-operation {
				.operator {
					margin: 0 .25rem;
				}
				.operands {
					.operand {
						line-height: 1;
					}
				}
			}
			.line{
				margin-top: -0.1em;
			}
			.result {}
		}
	}
</style>